import { render, staticRenderFns } from "./ImageVideo.vue?vue&type=template&id=ccf0f494&scoped=true"
import script from "./ImageVideo.vue?vue&type=script&lang=js"
export * from "./ImageVideo.vue?vue&type=script&lang=js"
import style0 from "./ImageVideo.vue?vue&type=style&index=0&id=ccf0f494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf0f494",
  null
  
)

export default component.exports